import React from 'react'
import { object } from 'prop-types'
import changeFileExtension from '@/lib/filename-extension-modifier'
import ProfileHeader from '@/component/Primitive/ProfileHeader'
import ProfileLink from '@/component/Primitive/ProfileHeader/component/ProfileLink'

const AuthorProfile = ({ pageData }) => {
  const { author } = pageData

  const formattedAuthor = {
    heading: author?.name,
    subHeading: author.jobTitle,
    description: author.description,
    src: author.images.headshot_220x347_576
      ? author.images.headshot_220x347_576[0].url
      : null,
    srcSet: [220, 576, 720, 900]
      .map((size) => {
        if (!author.images[`headshot_220x347_${size}`]) return null
        return {
          width: size,
          src: changeFileExtension(
            author.images[`headshot_220x347_${size}`][0].url,
            'webp'
          )
        }
      })
      .filter((i) => i),
    imageRatio: 347 / 220
  }

  return (
    <ProfileHeader {...formattedAuthor}>
      {author.linkedinId && (
        <ProfileLink
          url={`https://www.linkedin.com/in/${author.linkedinId}`}
          type="linkedin"
        >
          Follow on LinkedIn
        </ProfileLink>
      )}
      {author.twitterId && (
        <ProfileLink
          url={`https://www.twitter.com/${author.twitterId}`}
          type="twitter"
        >
          Follow on Twitter
        </ProfileLink>
      )}
    </ProfileHeader>
  )
}

AuthorProfile.propTypes = {
  pageData: object
}

export default AuthorProfile
